import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

import "./HomeAwards.css";


const awards = [
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Prolight%20Zambia.svg",
    text: "People Choice Award Zambia",
    year: "2018 & 2023",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Ethiopian.svg",
    text: "Certificate of Appreciation – outstanding support",
    year: "2023–2024",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Rwand%20Air.svg",
    text: "Award from Rwanda Airlines for Best Agency",
    year: "2017 & 2023",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Air%20Namibia.svg",
    text: "Certificate of Appreciation for outstanding support",
    year: "2015",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Kenya%20Airways.svg",
    text: "Certificate of Appreciation for outstanding support",
    year: "2019 & 2022",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Air%20Tanzania.svg",
    text: "Certificate of Appreciation for outstanding support",
    year: "2023",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Royal%20Air%20Maroc.svg",
    text: "Certificate of Appreciation for outstanding support",
    year: "2020–21-22-23",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Aitlink.svg",
    text: "Outstanding Performer – Angola",
    year: "2025",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Egypt%20air.svg",
    text: "Award of Appreciation for outstanding support",
    year: "2020-21-22-23-25",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Delta.svg",
    text: "Certificate of Appreciation for outstanding support",
    year: "2022–2023",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Emirates.svg",
    text: "Certificate of Appreciation for outstanding support",
    year: "2022–23-24-25",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Brussels%20Airlines.svg",
    text: "Certificate of Appreciation for outstanding support",
    year: "2023",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/tbo.com.svg",
    text: "Certificate of Appreciation for outstanding support",
    year: "2023-24",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/UTB.svg",
    text: "Uganda Tourism Board License",
    year: "since 2017",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/OMAN%20Air.svg",
    text: "Certificate of Appreciation for outstanding support",
    year: "2022",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Air%20India.svg",
    text: "Certificate of Appreciation for outstanding support",
    year: "2022",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Air%20Seychelles.svg",
    text: "Top Achiever Award – Namibia",
    year: "2025",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/South%20African%20Airways.svg",
    text: "Fastest Growing Travel Agency, Namibia",
    year: "2024–2025",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Air%20Mauritius.svg",
    text: "Certificate of Appreciation as a Top Travel Agency",
    year: "2026",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Air%20madagascar.svg",
    text: "Certificate of Appreciation as a Top Travel Agency",
    year: "2025",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/APG.svg",
    text: "Certificate of Sales – Top 10 Bestseller, Ghana",
    year: "2025",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Air%20Arabia.svg",
    text: "Certificate of Top Performer (Kenya)",
    year: "2023",
  },
  {
    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Website%20Airline%20logos/Qatar%20Airways.svg",
    text: "Certificate of Appreciation for outstanding support",
    year: "2019-2022",
  },
];



export const HomeAwards = () => {
  return (
    <section className="home-awards standard-padding px-0">
      <h1 className="heading mb-4">Our Awards & Recognitions</h1>

      <div className="awards-slider-wrapper">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={10}
          slidesPerView={9}
          loop={true}
          speed={4000} // smooth movement
          autoplay={{
            delay: 0, // continuous scroll
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: { slidesPerView: 2 },
            600: { slidesPerView: 3 },
            900: { slidesPerView: 4 },
            1200: { slidesPerView: 7 },
          }}
          className="awards-swiper"
        >
          {awards.map((item, i) => (
            <SwiperSlide key={i}>
              <div className="award-card">
                <img src={item.img} alt="" />
                <p>{item.text}</p>

                {item.year && <div className="award-year">{item.year}</div>}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Blur overlays */}
        <div className="fade-left"></div>
        <div className="fade-right"></div>
      </div>
    </section>
  );
};

export default HomeAwards;
